import { render } from "./IntroductionPage.vue?vue&type=template&id=27084642&scoped=true"
import script from "./IntroductionPage.vue?vue&type=script&lang=js"
export * from "./IntroductionPage.vue?vue&type=script&lang=js"

import "./IntroductionPage.vue?vue&type=style&index=0&id=27084642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27084642"]])

export default __exports__